import isEmpty from 'lodash/isEmpty';



const getTestModeParams = () => !isEmpty(localStorage.getItem('test_mode_params')) ? JSON.parse(localStorage.getItem('test_mode_params')) : {};

export default getTestModeParams;
